/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, Overrides } from "ethers";
import { Signer } from "@ethersproject/abstract-signer";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "./common";
import type {
  VetoPlugin,
  VetoPluginInterface,
} from "./VetoPlugin";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "dao",
        type: "address",
      },
      {
        internalType: "address",
        name: "where",
        type: "address",
      },
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "permissionId",
        type: "bytes32",
      },
    ],
    name: "DaoUnauthorized",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "limit",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "actual",
        type: "uint64",
      },
    ],
    name: "DateOutOfBounds",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "limit",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "actual",
        type: "uint64",
      },
    ],
    name: "MinDurationOutOfBounds",
    type: "error",
  },
  {
    inputs: [],
    name: "NoVotingPower",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "ProposalCreationForbidden",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalExecutionForbidden",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "limit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "actual",
        type: "uint256",
      },
    ],
    name: "RatioOutOfBounds",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "enum IMajorityVoting.VoteOption",
        name: "voteOption",
        type: "uint8",
      },
    ],
    name: "VoteCastForbidden",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAmount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "CancelVote",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_reference",
        type: "string",
      },
    ],
    name: "Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "members",
        type: "address[]",
      },
    ],
    name: "MembersAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "members",
        type: "address[]",
      },
    ],
    name: "MembersRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "definingContract",
        type: "address",
      },
    ],
    name: "MembershipContractAnnounced",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "startDate",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "endDate",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "metadata",
        type: "bytes",
      },
      {
        components: [
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        indexed: false,
        internalType: "struct IDAO.Action[]",
        name: "actions",
        type: "tuple[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "allowFailureMap",
        type: "uint256",
      },
    ],
    name: "ProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newTax",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "oldTax",
        type: "uint256",
      },
    ],
    name: "TaxChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "voter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum IMajorityVoting.VoteOption",
        name: "voteOption",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "votingPower",
        type: "uint256",
      },
    ],
    name: "VoteCast",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum MajorityVotingBase.VotingMode",
        name: "votingMode",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "supportThreshold",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "minParticipation",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "minDuration",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minProposerVotingPower",
        type: "uint256",
      },
    ],
    name: "VotingSettingsUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "TAX_PERMISSION_ID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPDATE_VOTING_SETTINGS_PERMISSION_ID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADE_PLUGIN_PERMISSION_ID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VETO_PERMISSION_ID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "canExecute",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_voter",
        type: "address",
      },
      {
        internalType: "enum IMajorityVoting.VoteOption",
        name: "_voteOption",
        type: "uint8",
      },
    ],
    name: "canVote",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "cancelVote",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tax",
        type: "uint256",
      },
    ],
    name: "changeTax",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_metadata",
        type: "bytes",
      },
      {
        components: [
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct IDAO.Action[]",
        name: "_actions",
        type: "tuple[]",
      },
      {
        internalType: "uint256",
        name: "_allowFailureMap",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_startDate",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "_endDate",
        type: "uint64",
      },
      {
        internalType: "enum IMajorityVoting.VoteOption",
        name: "_voteOption",
        type: "uint8",
      },
      {
        internalType: "bool",
        name: "_tryEarlyExecution",
        type: "bool",
      },
    ],
    name: "createProposal",
    outputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "dao",
    outputs: [
      {
        internalType: "contract IDAO",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_reference",
        type: "string",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "execute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "getProposal",
    outputs: [
      {
        internalType: "bool",
        name: "open",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "executed",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "enum MajorityVotingBase.VotingMode",
            name: "votingMode",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "supportThreshold",
            type: "uint32",
          },
          {
            internalType: "uint64",
            name: "startDate",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "endDate",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "snapshotBlock",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "minVotingPower",
            type: "uint256",
          },
        ],
        internalType: "struct MajorityVotingBase.ProposalParameters",
        name: "parameters",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "abstain",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "yes",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "no",
            type: "uint256",
          },
        ],
        internalType: "struct MajorityVotingBase.Tally",
        name: "tally",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct IDAO.Action[]",
        name: "actions",
        type: "tuple[]",
      },
      {
        internalType: "uint256",
        name: "allowFailureMap",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_voter",
        type: "address",
      },
    ],
    name: "getVoteOption",
    outputs: [
      {
        internalType: "enum IMajorityVoting.VoteOption",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getVotingToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "implementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IDAO",
        name: "_dao",
        type: "address",
      },
      {
        components: [
          {
            internalType: "enum MajorityVotingBase.VotingMode",
            name: "votingMode",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "supportThreshold",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "minParticipation",
            type: "uint32",
          },
          {
            internalType: "uint64",
            name: "minDuration",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "minProposerVotingPower",
            type: "uint256",
          },
        ],
        internalType: "struct MajorityVotingBase.VotingSettings",
        name: "_votingSettings",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "initializeBuild",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "isMember",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "isMinParticipationReached",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "isSupportThresholdReached",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "isSupportThresholdReachedEarly",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minDuration",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minParticipation",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minProposerVotingPower",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pluginType",
    outputs: [
      {
        internalType: "enum IPlugin.PluginType",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "supportThreshold",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "_interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_blockNumber",
        type: "uint256",
      },
    ],
    name: "totalVotingPower",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "enum MajorityVotingBase.VotingMode",
            name: "votingMode",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "supportThreshold",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "minParticipation",
            type: "uint32",
          },
          {
            internalType: "uint64",
            name: "minDuration",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "minProposerVotingPower",
            type: "uint256",
          },
        ],
        internalType: "struct MajorityVotingBase.VotingSettings",
        name: "_votingSettings",
        type: "tuple",
      },
    ],
    name: "updateVotingSettings",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
      {
        internalType: "enum IMajorityVoting.VoteOption",
        name: "_voteOption",
        type: "uint8",
      },
      {
        internalType: "bool",
        name: "_tryEarlyExecution",
        type: "bool",
      },
    ],
    name: "vote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "votingMode",
    outputs: [
      {
        internalType: "enum MajorityVotingBase.VotingMode",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type VetoPluginConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VetoPluginConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VetoPlugin__factory extends ContractFactory {
  constructor(...args: VetoPluginConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<VetoPlugin> {
    return super.deploy(overrides || {}) as Promise<VetoPlugin>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): VetoPlugin {
    return super.attach(address) as VetoPlugin;
  }
  override connect(signer: Signer): VetoPlugin__factory {
    return super.connect(signer) as VetoPlugin__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VetoPluginInterface {
    return new utils.Interface(_abi) as VetoPluginInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VetoPlugin {
    return new Contract(address, _abi, signerOrProvider) as VetoPlugin;
  }
}
